import React, { useEffect, useState, useContext } from 'react';
import { ApiContext } from '../../contexts/ApiContext';
import CategoryService from '../../service/category.service';
import CategoryForm from './CategoryForm';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal/ConfirmDeleteModal';
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
} from 'reactstrap';

const CategoriesPage = () => {
  const { account } = useContext(ApiContext);
  const accountId = account && account.id;
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  const fetchCategories = async () => {
    if (!accountId) return;
    const res = await CategoryService.getByAccount(accountId);
    setCategories(res || []);
  };

  useEffect(() => {
    fetchCategories();
  }, [accountId]);

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    await CategoryService.remove(id);
    fetchCategories();
  };

  const confirmDelete = (category) => {
    setToDelete(category);
    setShowDelete(true);
  };

  const handleFormClose = () => {
    setEditingCategory(null);
    setShowForm(false);
    fetchCategories();
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="flex">
                <CardTitle tag="h4">Categorias do Cardápio</CardTitle>
                <Button onClick={() => setShowForm(true)} className="btn-fill" color="primary">
                  Nova Categoria
                </Button>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Nome</th>
                      <th>Status</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat) => (
                      <tr key={cat.id}>
                        <td>{cat.name}</td>
                        <td>{cat.active ? 'Ativa' : 'Inativa'}</td>
                        <td className="text-center">
                          <Button className="btn-fill" color="info" size="sm" title="Editar" onClick={() => handleEdit(cat)}>
                             <i className="tim-icons icon-pencil" />
                          </Button>{' '}
                          <Button className="btn-fill" color="danger" size="sm" title="Excluir" onClick={() => confirmDelete(cat)}>
                             <i className="tim-icons icon-trash-simple" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <CategoryForm category={editingCategory} onClose={handleFormClose} accountId={accountId} show={showForm} setShow={setShowForm} />
      <ConfirmDeleteModal
        isOpen={showDelete}
        toggle={() => setShowDelete(!showDelete)}
        message={toDelete ? `Deseja realmente excluir a categoria "${toDelete.name}"?` : 'Deseja realmente excluir?' }
        onConfirm={() => toDelete && handleDelete(toDelete.id)}
      />
    </>
  );
};

export default CategoriesPage;
